
// PrimaryGroup.js
import React from 'react';
import GroupComponent from './GroupComponent';

const PrimaryGroup = (props) => {
  return (
    <GroupComponent 
      {...props} 
      groupType="primary" 
      actionSummary={props.actionSummary} 
    />
  );
};

export default PrimaryGroup;